import { styled } from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

export const HeaderCopy = styled.div`
  display: grid;
  gap: 4px;
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
`;

export const FilterField = styled.label`
  display: grid;
  gap: 6px;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;

  .ant-select,
  .ant-input-number {
    width: 100%;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const ResultsRegion = styled.section`
  margin-top: 16px;
`;

export const EmptyState = styled.div`
  display: grid;
  justify-items: center;
  gap: 12px;
  padding: 48px 24px;
  text-align: center;
`;

export const FailureDetails = styled.div`
  display: grid;
  gap: 6px;
`;
